<template>
  <header class="d-flex position-relative align-items-center gap-4 mb-4">
    <MarketplaceBackButton v-if="!isNuxtLink" :disabled="disabled" :invisible="!renderButton" @submit="btnSubmit" />
    <MarketplaceBackButton v-if="isNuxtLink" :disabled="disabled" :invisible="!renderButton" :nuxtLink="backLink" />
    <p class="d-lg-none flex-grow-1 type-500 m-0" :class="renderButton ? 'ms-4' : 'position-absolute start-0 end-0 text-center'">{{ headerTitle }}</p>
  </header>
</template>

<script>
import MarketplaceBackButton from '~/components/marketplace/MarketplaceBackButton.vue'

export default {
  props: {
    backLink: String,
    btnSubmit: Function,
    headerTitle: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isNuxtLink: Boolean,
    renderButton: Boolean
  },
  components: {
    MarketplaceBackButton
  }
}
</script>

<style scoped lang="scss">
@import 'assets/styles/global';
</style>
